module.exports = __webpack_public_path__ + "img/bank-2.3792725e.jpg";